import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const DIALOG_CLOSE = new InjectionToken<Observable<any>>('DIALOG_CLOSE');
